import { track } from '@/lib/analytics/track';
import { TrackingEventName } from '@/models/analytics/eventTypes';
import { type EvidenceSignUpWall } from '@/models/analytics/features/evidence';
import { useCallback } from 'react';

/**
 * Returns a stable callback that fires the EvidenceSignUpWallViewed
 * analytics event for the given wall type.
 */
export function useTrackSignUpWallViewed() {
  return useCallback((wallType: EvidenceSignUpWall) => {
    track({
      options: { amplitude: false },
      event_name: TrackingEventName.EvidenceSignUpWallViewed,
      props: { wall_type: wallType },
    });
  }, []);
}
